if (!customElements.get('tr-extra-products')) {
class TrExtraProducts extends HTMLElement {
	selectors = {
		native: '[data-tr-js-select-native]',
		priceItem: '.price-item'
	};

	attributes = {
		priceSelector: 'data-tr-js-price-selector',
		variantPrice: 'data-tr-js-variant-price',
		extraRole: 'data-tr-js-extra-role',
		firstFree: 'data-tr-js-first-free',
		label: 'data-tr-js-label'
	};

	connectedCallback() {
		this.selectElements = [...this.querySelectorAll(this.selectors.native)];
		this.priceRoot = document.querySelector(this.getAttribute(this.attributes.priceSelector));
		this.productInfoElement = this.closest('product-info');

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.updatePrice();
	}

	bindEvents() {
		this.selectElements.forEach((selectElement) => {
			selectElement.addEventListener('change', this.onSelectChange);
		});
		this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
	}

	onSelectChange = () => {
		this.updatePrice();
	};

	onVariantChange = ({ data: { sectionId, variant } }) => {
		if (sectionId !== this.productInfoElement?.dataset.section || variant == null) return;

		this.priceRoot?.setAttribute(this.attributes.variantPrice, String(variant.price));
		this.updatePrice();
	};

	updatePrice() {
		if (this.priceRoot == null) return;

		const formattedPrice = Shopify.formatMoney(this.variantPrice + this.extraPrice, window.Money_Format);

		this.currentPriceItems.forEach((priceItem) => {
			priceItem.textContent = formattedPrice;
		});
	}

	getOrderedSelectedOptions(selectElement) {
		const selectComponent = selectElement.closest('tr-select');
		const selectedValues = selectComponent?.getSelectedValues?.() ||
			[...selectElement.selectedOptions].map((option) => option.value).filter(Boolean);

		return selectedValues
			.map((value) => [...selectElement.options].find((option) => option.value === value))
			.filter(Boolean);
	}

	getExtrasFromSelect(selectElement) {
		const firstFree = selectElement.hasAttribute(this.attributes.firstFree);

		return this.getOrderedSelectedOptions(selectElement).reduce((extras, option, index) => {
			const variantId = Number(option.value) || 0;

			if (!variantId) return extras;

			extras.push({
				variantId,
				priceCents: firstFree && index === 0 ? 0 : Number(option.dataset.trJsPrice) || 0,
				label: option.getAttribute(this.attributes.label) || ''
			});

			return extras;
		}, []);
	}

	getSelectedExtras() {
		const extras = {
			seasonings: [],
			addOn: null
		};

		(this.selectElements || []).forEach((selectElement) => {
			const role = selectElement.getAttribute(this.attributes.extraRole);
			const selectedExtras = this.getExtrasFromSelect(selectElement);

			if (role === 'main_seasoning') extras.seasonings = selectedExtras;
			if (role === 'add_on') extras.addOn = selectedExtras[0] || null;
		});

		return extras;
	}

	get variantPrice() {
		return Number(this.priceRoot?.getAttribute(this.attributes.variantPrice)) || 0;
	}

	get extraPrice() {
		const extras = this.getSelectedExtras();

		return extras.seasonings.reduce((total, extra) => total + extra.priceCents, extras.addOn?.priceCents || 0);
	}

	get currentPriceItems() {
		return [...this.priceRoot.querySelectorAll(this.selectors.priceItem)].filter(
			(priceItem) => priceItem.closest('s') == null
		);
	}

	destroy() {
		(this.selectElements || []).forEach((selectElement) => {
			selectElement.removeEventListener('change', this.onSelectChange);
		});
		this.onVariantChangeUnsubscriber?.();
	}
}

	customElements.define('tr-extra-products', TrExtraProducts);
}
